import _                                    from 'underscore';
import React, { FC, useContext }            from 'react';
import { formatOption, IFormatOptionValue } from '../../../../util';
import { PreSelectedSelectField, Uuid }     from '../../../../types';
import { PROJECT_MILESTONES }               from '../../../../constants/ProductEnums';
import { useProjectTermDictionary }         from '../../../../hooks/useTermDictionary';
import { SelectField }                      from '../../../components/forms';
import { useQuery }                         from "@apollo/react-hooks";
import { queriesHaveData, queriesLoading }  from "@src/store/_apolloUtil";
import { ProjectQueries }                   from "@src/queries/ProjectQueries";
import { ProjectContext }                   from "@src/views/pages/projects/ProjectIndexPage";
import { ProjectService }                   from "@src/services";


interface Props extends PreSelectedSelectField {
    projectId?: Uuid,
    projectVersionId?: Uuid,
}

const defaultProps: Props = {
    projectId:        null,
    projectVersionId: null,
}

const Dropdown: FC<Props> = ( props ) => {

    let projectContext                  = useContext( ProjectContext ),
        { projectId, projectVersionId } = projectContext || props,
        { getTerm }                     = useProjectTermDictionary();

    if( !projectId || !projectVersionId ) return null;

    const getProjectVersionMilestonesReq = useQuery(
        ProjectQueries.queries.GET_PROJECT( `
            projectVersions{
                id
                projectVersionMilestones { 
                    id
                    name
                    startDate
                    milestoneType
                }
            }
        ` ), {
            variables:   {
                id: projectId
            },
            fetchPolicy: 'cache-and-network'
        } );

    const isLoading = ( props.loading || queriesLoading( getProjectVersionMilestonesReq ) );

    let options = [] as IFormatOptionValue[];

    if( queriesHaveData( getProjectVersionMilestonesReq ) ){

        const project                  = _.first( getProjectVersionMilestonesReq.data.projects ),
              projectVersion           = ProjectService.getProjectVersionById( project?.projectVersions, projectVersionId ),
              projectVersionMilestones = projectVersion?.projectVersionMilestones;

        _.sortBy( projectVersionMilestones, 'startDate' ).map( projectVersionMilestone => {

            const { id, name, milestoneType } = projectVersionMilestone,
                  isSystemMilestone           = Object.values( PROJECT_MILESTONES ).includes( milestoneType ),
                  milestoneName               = isSystemMilestone ? getTerm( ProjectService.getMilestoneInfoFromType( milestoneType as any ).LABEL ) : name;

            options.push(
                formatOption( id, milestoneName )
            );
        } )
    }

    return (
        <SelectField
            { ...props }
            loading={ isLoading }
            options={ options }>
        </SelectField>
    );
};

Dropdown.defaultProps = defaultProps;

export { Dropdown as ProjectVersionTimeMilestonesDropdown };
